import React from "react";
import { handleAddBot, handleRemovePlayer, handleStartGame } from "api";
import JoinLink from "./JoinLink";
import { GameState } from "types";
import Rank from "components/Rank";

interface Props {
  clientId: string;
  gameState: GameState;
  users: any;
}

const LobbyInterface: React.FC<Props> = ({ clientId, gameState, users }) => {
  if (gameState?.spectatorIds.includes(clientId)) return null;

  return (
    <div className="flex-grow">
      <div className="flex flex-col space-y-2 my-2">
        <h2 className="text-center text-3xl font-semibold">
          Lobby - {gameState.gameName}
        </h2>
        {gameState.playerIds.map((cId) => (
          <div
            key={cId}
            className="w-full p-4 rounded bg-white shadow flex items-baseline space-x-2"
          >
            <Rank rating={users[cId]?.rating} />
            <h3 className="font-semibold text-2xl">
              {gameState.players[cId].publicName}
            </h3>
            {gameState.host === cId && <h4>Host</h4>}
            {cId === clientId ? <h4>You</h4> : <button className="text-2xl text-red-500" onClick={() => handleRemovePlayer(clientId, gameState?.id, cId)}>&times;</button>}
          </div>
        ))}
        {[...Array(4 - gameState.playerIds.length)].map((_, i) => (
          <div
            key={i}
            className="w-full p-4 rounded bg-gray-200 text-gray-600 items-baseline space-x-2 text-2xl"
          >
            Player {i+gameState.playerIds.length+1}
          </div>
        ))}
      </div>
      <div>
        {gameState?.host === clientId && (
          <button
            className="px-2 py-1 bg-gray-700 rounded border text-gray-100 w-full"
            onClick={() => handleStartGame(clientId, gameState?.id)}
          >
            Start game
          </button>
        )}
        {gameState?.host === clientId && (
          <button
            className="px-2 py-1 bg-gray-700 rounded border text-gray-100 w-full"
            onClick={() => handleAddBot(clientId, gameState?.id)}
          >
            Add bot
          </button>
        )}
        <JoinLink gameId={gameState.id} />
      </div>
    </div>
  );
};

export default LobbyInterface;
